import type { ReactNode } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { avatarColorClass } from '@/lib/utils/avatar';
import { cn } from '@/lib/utils/cn';
import type { UserMenuSubject } from './types';

interface UserMenuCompanyCardProps {
  company: UserMenuSubject;
  /** Slot under the company name — the client app puts its "View profile" link here. */
  children?: ReactNode;
}

/** Names the company the session is scoped to. */
export function UserMenuCompanyCard({
  company,
  children,
}: UserMenuCompanyCardProps) {
  return (
    <div className='px-3 py-2.5 bg-muted/30'>
      <div className='flex items-center gap-2.5'>
        {/* Rounded square, as a company `EntityAvatar`: the corner is the
            token for a 36px box. */}
        <Avatar className='h-9 w-9 shrink-0 rounded-md after:rounded-md'>
          <AvatarImage
            src={company.imageUrl}
            alt={company.name}
            className='rounded-md'
          />
          <AvatarFallback
            delay={0}
            className={cn(
              'rounded-md text-sm font-semibold',
              avatarColorClass(company.colorSeed),
            )}
          >
            {company.initials}
          </AvatarFallback>
        </Avatar>
        <div className='min-w-0 flex-1'>
          <p className='text-sm font-semibold truncate'>{company.name}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
